import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { ICompaniesQueryParams, ICompany, IQueryResult } from 'gen/ApiClient';

export const CompaniesQueryContext = React.createContext<IQueryContext<IQueryResult<ICompany>, ICompaniesQueryParams>>(undefined as any);
